const getKeywordsMap = (t: (key: string) => string): Record<string, string> => ({
  value_for_money: t("propertypage.components.reviewssection.valueformoney"),
  staff: t("propertypage.components.reviewssection.staffandmanagement"),
  internet: t("propertypage.components.reviewssection.internetandwifi"),
  social: t("propertypage.components.reviewssection.socialexperience"),
  cleaning: t("propertypage.components.reviewssection.cleanliness"),
  amenities: t("propertypage.components.reviewssection.amenities"),
  location: t("propertypage.components.reviewssection.localition"),
});

export const getKeywordsMapIcon = {
  value_for_money: "Value for Money",
  staff: "Staff & Management",
  internet: "Internet / Wifi",
  social: "Social Experience",
  cleaning: "Cleanliness",
  amenities: "Amenities",
  location: "Location",
};

export const RATING_CATEGORIES = [
  {
    id: 1,
    label: {
      desktop: "Value for money",
      mobile: "Value for money",
    },
    key: "value_for_money",
  },
  {
    id: 2,
    label: {
      desktop: "Staff and Management",
      mobile: "Staff & Management",
    },
    key: "staff_and_Management",
  },
  {
    id: 3,
    label: {
      desktop: "Internet and Wi-Fi",
      mobile: "Internet and Wi-Fi",
    },
    key: "internet_and_wi_fi",
  },
  {
    id: 4,
    label: {
      desktop: "Social Experience",
      mobile: "Social Experience",
    },
    key: "social_experience",
  },
  {
    id: 5,
    label: {
      desktop: "Cleaning",
      mobile: "Cleaning",
    },
    key: "cleaning",
  },
  {
    id: 6,
    label: {
      desktop: "Overall Amenities",
      mobile: "Overall Amenities",
    },
    key: "overall_amentities",
  },
  {
    id: 7,
    label: {
      desktop: "Localities",
      mobile: "Localities",
    },
    key: "localities",
  },
];

export default getKeywordsMap;
